import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa6';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2'
import { FaFileImage } from 'react-icons/fa';

const Vehicle = ({setLoading}) => {

       const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [searchTerm, setSearchTerm] = useState('');
    const [vehicleDetail, setVehicleDetail] = useState([]);

    const [showDelete, setShowDelete] = useState(false);
    const [selectedRoute, setSelectRoute] = useState('');
const [isEdit, setIsEdit] = useState(false);
const [editId, setEditId] = useState(null);


    const handleDelete = async (id) => {
        setLoading(true);
        try {
            const res = await axios.delete(`https://api.kcian.in/delete-vehicle/${id}`);

                        setResponse2({ message: 'Vehicle Removed Successfully.', status: 'success' });
                        setShowDelete(false);
fetchVehicle();
        } catch (err) {
            console.error(err.response?.data || err.message);
        } finally {
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
                    setLoading(false);
        }
    };


    const [formData, setFormData] = useState({
        vehicle_no: '',
        vehicle_model: '',
        year: '',
        driver: '',

        note: '',
        phone: '',
        license: null
    });




const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (type === "file") {
        const file = files[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                alert("Only image files are allowed for License.");
                return;
            }
            setFormData({
                ...formData,
                [name]: file,
            });
        }
    } else {
        setFormData({
            ...formData,
            [name]: value,
        });
    }
};


const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const sendData = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            sendData.append(key, value);
        });

        let res;

        if (isEdit) {
            // Edit mode
            res = await axios.put(
                `https://api.kcian.in/update-vehicle/${editId}`,
                sendData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            setResponse2({ message: 'Vehicle Updated Successfully.', status: 'success' });
        } else {
            res = await axios.post(
                "https://api.kcian.in/add-vehicle",
                sendData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            setResponse2({ message: 'Vehicle Added Successfully.', status: 'success' });
        }

        fetchVehicle();
        setFormData({
            vehicle_no: '',
            vehicle_model: '',
            year: '',
            driver: '',
            note: '',
            phone: '',
            license: null
        });
        setIsEdit(false);
        setEditId(null);
    } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
    } finally {
        setLoading(false);
        setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
};


const handleEdit = (vehicle) => {
    setFormData({
        vehicle_no: vehicle.vehicle_no,
        vehicle_model: vehicle.vehicle_model,
        year: vehicle.year,
        driver: vehicle.driver,
        note: vehicle.note || '',
        phone: vehicle.phone,
        license: null
    });
    setIsEdit(true);
    setEditId(vehicle.id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
};


        const fetchVehicle = async () => {
            setLoading(true);
            try {
                const res = await axios.get('https://api.kcian.in/fetch-vehicle');
                setVehicleDetail(res.data);
            setLoading(false);

            } catch (error) {
            setLoading(false);
                console.log(error)
            }
        };

    useEffect(() => {
        fetchVehicle();
    }, []);


    const filteredData = vehicleDetail.filter((r) => {
        const term = searchTerm.toLowerCase();
        return (
            r.vehicle_model.toLowerCase().includes(term) ||
            r.driver.toLowerCase().includes(term) ||
            r.phone.toLowerCase().includes(term)
        )
    });


    const handleShowDelete = (item) => {
        setSelectRoute(item);
        setShowDelete(true);
    }
    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Transport' message2='Vehicle' />
                    <div className='row'>

                        <div className='px-2'>
                         {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}</div>

                        <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                            <div className="profile-card">
                                <p className="profile-heading">Add Vehicle</p>
                                <form className='mt-4' onSubmit={handleSubmit} >
                                        {/* Vehicle Number */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Vehicle Number*</label>
                                            <input
                                                type="text"
                                                name="vehicle_no"
                                                className="profile-input"
                                                value={formData.vehicle_no}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Vehicle Model */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Vehicle Model*</label>
                                            <input
                                                type="text"
                                                name="vehicle_model"
                                                className="profile-input"
                                                value={formData.vehicle_model}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Year Made */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Year Made*</label>
                                            <input
                                                type="text"
                                                name="year"
                                                className="profile-input"
                                                value={formData.year}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Driver */}
                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Driver Name*</label>
                                            <input
                                                type="text"
                                                name="driver"
                                                className="profile-input"
                                                value={formData.driver}
                                                onChange={handleChange}
                                                required
                                            />

                                        </div>

                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Phone No*</label>
                                            <input
                                                type="text"
                                                name="phone"
                                                className="profile-input"
                                                maxLength={10}
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">License (Image)</label>
                                            <input
                                                type="file"
                                                name="license"
                                                className="profile-input"
accept="image/*"
                                                onChange={handleChange}

                                            />
                                        </div>

                                        {/* Note */}
                                        <div className="profile-input-area mb-4">
                                            <label htmlFor="note" className="profile-badge">
                                                Note
                                            </label>
                                            <textarea id='note' name="note" className="profile-input"
                                                value={formData.note}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {/* Button */}
                                        <div className="text-center">
                                            <button className="profile-btn me-2" type='submit' >
{isEdit ? <><MdOutlineEdit /> UPDATE</> : <><FaCheck /> SAVE</>}
                                                </button>
                                                              {isEdit && (
    <button
      type="button"
      className="profile-btn2"
      onClick={() => {
        setFormData({vehicle_no: '',
        vehicle_model: '',
        year: '',
        driver: '',
        note: '',
        phone: '',
        license: null});
        setIsEdit(false);
        setEditId(null);
      }}
    >
      Cancel
    </button>
)}
                                        </div>
                                </form>
                            </div>
                        </div>
                        {/* table */}
                        <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                            <div className='profile-card'>

                                <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                    <span className="profile-heading align-content-center">Vehicle List</span>

                                    <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                        <input
                                            type='text'
                                            name='search'
                                            className='profile-input border-bottom rounded-0'
                                            placeholder='Search...'
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='w-100 text-center'>

                                        <thead className='account-thead'>
                                            <tr>
                                                <th className='rounded-start-4'>Vehicle No</th>
                                                <th>Model No</th>
                                                <th>Year Made</th>
                                                <th>Driver Name</th>
                                                <th>Driver Phone</th>
                                                <th>Driver License</th>
                                                <th className='rounded-end-4'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((data, id) => (
                                                    <tr className='account-tr' key={id}>
                                                        {/* <td>{id + 1}</td> */}
                                                        <td>{data.vehicle_no}</td>
                                                        <td>{data.vehicle_model}</td>
                                                        <td>{data.year}</td>
                                                        <td>{data.driver}</td>
                                                                                 <td>{data.phone}</td>
<td>
                                                {data.license ? (() => {
                                                    // Extract file extension
                                                    const ext = data.license.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${data.license}`, '_blank');
                                                    };

if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td>                    
                                                        <td>
                                                             <MdOutlineEdit
        className="account-icon1 me-2"
        title="Edit"
        onClick={() => handleEdit(data)}
    />
                                                            <RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(data)} />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) :
                                                <tr>
                                                    <td colSpan="8" className="text-center py-3 text-muted">
                                                        No Data found.
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>


                                {showDelete && (
                                    <>
                                        <section className='ins-dialog'>
                                            <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

                                                <p className='ins-dialog-heading text-danger'>Remove This Vehicle!</p>

                                                <div className='table-responsive'>
                                                    <table className='w-100'>

                                                        <thead className='account-thead'>
                                                            <th className='rounded-start-4'>Vehicle No</th>
                                                              <th>Model No</th>
                                                <th>Year Made</th>
                                                <th>Driver Name</th>
                                                                                                <th>Driver Phone</th> 
                                                <th className='rounded-end-4'>Driver License</th>

                                                        </thead>

                                                        <tr className='account-tr'>
                                                            <td>{selectedRoute.vehicle_no}</td>
                                                            <td>{selectedRoute.vehicle_model}</td>
                                                            <td>{selectedRoute.year}  </td>
                                                              <td>{selectedRoute.driver}  </td>
                                                              <td>{selectedRoute.phone}  </td>
<td>
                                                {selectedRoute.license ? (() => {
                                                    const ext = selectedRoute.license.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedRoute.license}`, '_blank');
                                                    };

if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td>                                                                   </tr>


                                                    </table>
                                                </div>

                                                <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Vehicle will be permanently removed.</p>

                                                <button className='profile-btn me-2' onClick={() => handleDelete(selectedRoute.id)}>Remove</button>
                                                <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


                                            </div>
                                        </section>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Vehicle